// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("assets/js/chunks/" + chunkId + ".507a3108-c005-456b-8481-4516bba7393c.js");